import React, { useState, useEffect } from 'react'
import { Eye, EyeOff, Lock, CheckCircle, XCircle, ArrowLeft } from 'lucide-react'
import { api } from '../services/api'
import { useNavigate, useSearchParams } from 'react-router-dom'

const RecuperarSenha = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const token = searchParams.get('token')
  
  const [formData, setFormData] = useState({
    nova_senha: '',
    confirmar_senha: ''
  })
  
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [tokenValido, setTokenValido] = useState(false)
  const [validandoToken, setValidandoToken] = useState(true)
  
  useEffect(() => {
    if (!token) {
      setMessage('❌ Token não fornecido')
      setValidandoToken(false)
      return
    }
    
    // Aqui você pode validar o token se necessário
    // Por enquanto, assumimos que é válido se foi fornecido
    setTokenValido(true)
    setValidandoToken(false)
  }, [token])
  
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
    setMessage('') // Limpar mensagem ao digitar
  }
  
  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (formData.nova_senha !== formData.confirmar_senha) {
      setMessage('❌ As senhas não coincidem')
      return
    }
    
    if (formData.nova_senha.length < 6) {
      setMessage('❌ A senha deve ter pelo menos 6 caracteres')
      return
    }
    
    setLoading(true)
    setMessage('')
    
    try {
      const response = await api.post('/auth/redefinir-senha.php', {
        token: token,
        nova_senha: formData.nova_senha,
        confirmar_senha: formData.confirmar_senha
      })
      
      if (response.ok) {
        setMessage('✅ Senha redefinida com sucesso! Redirecionando...')
        setTimeout(() => {
          navigate('/login')
        }, 2000)
      } else {
        setMessage(`❌ ${response.message}`)
      }
    } catch (err) {
      console.error('Erro ao redefinir senha:', err)
      setMessage('❌ Erro de conexão. Tente novamente.')
    } finally {
      setLoading(false)
    }
  }
  
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }
  
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword)
  }
  
  if (validandoToken) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-400">Validando token...</p>
        </div>
      </div>
    )
  }
  
  if (!tokenValido) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div className="text-center">
            <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-red-100 dark:bg-red-900">
              <XCircle className="h-6 w-6 text-red-600 dark:text-red-400" />
            </div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 dark:text-white">
              Token Inválido
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600 dark:text-gray-400">
              {message}
            </p>
          </div>
          
          <div className="text-center">
            <button
              onClick={() => navigate('/login')}
              className="btn-outline"
            >
              <ArrowLeft className="h-5 w-5 mr-2" />
              Voltar ao Login
            </button>
          </div>
        </div>
      </div>
    )
  }
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-green-100 dark:bg-green-900">
            <CheckCircle className="h-6 w-6 text-green-600 dark:text-green-400" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 dark:text-white">
            Redefinir Senha
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600 dark:text-gray-400">
            Digite sua nova senha
          </p>
        </div>
        
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label htmlFor="nova_senha" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Nova Senha
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Lock className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  id="nova_senha"
                  name="nova_senha"
                  type={showPassword ? 'text' : 'password'}
                  required
                  className="input pl-10 pr-10 w-full"
                  placeholder="Digite sua nova senha"
                  value={formData.nova_senha}
                  onChange={handleInputChange}
                  minLength="6"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? (
                    <EyeOff className="h-5 w-5 text-gray-400" />
                  ) : (
                    <Eye className="h-5 w-5 text-gray-400" />
                  )}
                </button>
              </div>
            </div>
            
            <div>
              <label htmlFor="confirmar_senha" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Confirmar Nova Senha
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Lock className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  id="confirmar_senha"
                  name="confirmar_senha"
                  type={showConfirmPassword ? 'text' : 'password'}
                  required
                  className="input pl-10 pr-10 w-full"
                  placeholder="Confirme sua nova senha"
                  value={formData.confirmar_senha}
                  onChange={handleInputChange}
                  minLength="6"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  onClick={toggleConfirmPasswordVisibility}
                >
                  {showConfirmPassword ? (
                    <EyeOff className="h-5 w-5 text-gray-400" />
                  ) : (
                    <Eye className="h-5 w-5 text-gray-400" />
                  )}
                </button>
              </div>
            </div>
          </div>
          
          {message && (
            <div className={`text-sm p-3 rounded-md ${
              message.includes('✅') 
                ? 'bg-green-50 text-green-800 dark:bg-green-900/20 dark:text-green-400' 
                : 'bg-red-50 text-red-800 dark:bg-red-900/20 dark:text-red-400'
            }`}>
              {message}
            </div>
          )}
          
          <div className="flex flex-col space-y-3">
            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
              ) : (
                'Redefinir Senha'
              )}
            </button>
            
            <button
              type="button"
              onClick={() => navigate('/login')}
              className="btn-outline w-full"
            >
              <ArrowLeft className="h-5 w-5 mr-2" />
              Voltar ao Login
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default RecuperarSenha
